import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../hooks/GlobalProvider";
import { useLocation } from "react-router-dom";
import {
  FaUser,
  FaGlobe,
  FaEnvelope,
  FaPhone,
  FaMoneyBillWave,
  FaCreditCard,
} from "react-icons/fa";

export default function Payment() {
  const { user } = useAuth();
  const location = useLocation();
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const domain = location.state?.domain;
  const passedAmount = location.state?.amount;

  useEffect(() => {
    if (domain) {
      setAmount(passedAmount || 12000);
    }
  }, [domain, passedAmount]);

  const handlePayNow = async () => {
    const txnid = `TXN${Date.now()}`;
    const productinfo = `Renewal for ${domain.user_domain}`;
    const firstname = user?.name;
    const email = user?.emailaddress;
    const phone = user?.phonenumber;
    const key = "BPAK8g"; //BPAK8g test//DWL3XA
    const surl = "https://crmgeni.com/apis/Payu/success.php";
    const furl = "https://crmgeni.com/apis/Payu/failure.php";

    if (!firstname || !email || !phone) {
      alert("User information is incomplete.");
      return;
    }

    if (!amount || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.post(
        "https://crmgeni.com/apis/Payu/generate_hash.php",
        {
          key,
          txnid,
          amount,
          productinfo,
          firstname,
          email,
        }
      );

      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://secure.payu.in/_payment";//https://test.payu.in/_payment

      const payload = {
        key,
        txnid,
        amount,
        productinfo,
        firstname,
        email,
        phone,
        surl,
        furl,
        hash: data.hash,
        udf1: "",
        udf2: "",
        udf3: "",
        udf4: "",
        udf5: "",
        udf6: "",
        udf7: "",
        udf8: "",
        udf9: "",
        udf10: "",
      };

      Object.entries(payload).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (err) {
      alert("Error initiating payment: " + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  if (!domain || !user) {
    return (
      <div className="text-center text-red-600 font-medium mt-10">
        Missing user or domain data. Please go back and try again.
      </div>
    );
  }

  return (
    <div className="p-6 max-w-xl mx-auto mt-16 bg-white rounded-2xl shadow-md">
      <h2 className="text-2xl font-bold text-center text-primary mb-6 flex items-center justify-center gap-2">
        <FaCreditCard /> Pay via PayU
      </h2>

      <div className="space-y-3 text-sm text-gray-700 mb-6">
        <p className="flex items-center gap-2">
          <FaUser className="text-yellow-600" /> Name: <span className="font-medium">{user.name}</span>
        </p>
        <p className="flex items-center gap-2">
          <FaEnvelope className="text-yellow-600" /> Email: <span className="font-medium">{user.emailaddress}</span>
        </p>
        <p className="flex items-center gap-2">
          <FaPhone className="text-yellow-600" /> Phone: <span className="font-medium">{user.phonenumber}</span>
        </p>
        <p className="flex items-center gap-2">
          <FaGlobe className="text-yellow-600" /> Domain: <span className="font-medium">{domain.user_domain}</span>
        </p>
      </div>

      <label htmlFor="amount" className="block text-gray-700 font-semibold mb-1">
        <FaMoneyBillWave className="inline-block mr-1 text-green-600" /> Amount (₹)
      </label>
      <input
        id="amount"
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder="Enter amount"
        className="border border-gray-300 p-2 w-full rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400"
        min="1"
      />

      <button
        onClick={handlePayNow}
        disabled={!amount || loading || amount <= 0}
        className="w-full bg-primary hover:bg-primary-100 text-white font-bold py-3 rounded-full transition disabled:bg-gray-400"
      >
        {loading ? "Processing Payment..." : "Pay Now"}
      </button>
    </div>
  );
}
